
function waitForElm(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                resolve(document.querySelector(selector));
                observer.disconnect();
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}


function waitForElements(selector) {
    return new Promise(resolve => {
        if (document.querySelectorAll(selector).length > 0) {
            return resolve(document.querySelectorAll(selector));
        }
  
        const observer = new MutationObserver(mutations => {
            if (document.querySelectorAll(selector).length > 0) {
              resolve(document.querySelectorAll(selector));
              observer.disconnect();
            }
        });
  
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
  }


document.addEventListener('DOMContentLoaded', () => {

    var moreOptionsBtn = document.createElement('div');
    moreOptionsBtn.className = "carets-moreOptions-btn";
    moreOptionsBtn.innerHTML = "BUY NOW";

    var btnContainer = document.createElement('div');
    btnContainer.className = "carets-button-container button button--secondary button--full-width";
    btnContainer.id = 'carets-btn-cont-id';

    var y = document.querySelector('.product-form__buttons');
    if (y !== null) {
        y.className += " carets-atc-buttons";
        btnContainer.appendChild(moreOptionsBtn);
        y.appendChild(btnContainer);

        btnContainer.addEventListener('click', function() {
            let shopifyMoreOptions = document.querySelector('.shopify-payment-button__more-options');
            shopifyMoreOptions.click();
        });
    }


    let variantOptions = document.querySelector('variant-radios');
    if (variantOptions !== null) {
        variantOptions.dispatchEvent(new Event('change'));
    }

    let colorImages = document.querySelectorAll('.product-grid-container .swatches__swatch');
    colorImages.forEach(function(colorImage) {
        let productImage = colorImage.closest('.card').querySelector('.card__inner img');
        colorImage.addEventListener('mouseover', function() {
            let image = colorImage.querySelector('input').dataset.variantImage;
            productImage.src = image;
        });

        colorImage.addEventListener('mouseout', function() {
            let image = colorImage.closest('.card').querySelector('.card__inner img').dataset.src;
            productImage.src = image;
        });
    });

    let collectionMenu = document.querySelector('.collection-menu');
    waitForElm('.boost-sd__filter-tree-vertical-option-list').then((filterList) => {
        if (filterList !== null) {
            filterList.insertBefore(collectionMenu, filterList.firstChild);
            collectionMenu.classList.remove('visually-hidden');
        }
    });

    waitForElements('.boost-sd__product-title').then((productItemTitles) => {
        productItemTitles.forEach(function(productItemTitle) {
            let title = productItemTitle.innerText;
            let titleSplit = []
            if (title.indexOf(' - ') > -1) {
                titleSplit = title.split(' - ');
            } else if (title.indexOf(', ') > -1) {
                titleSplit = title.split(', ');
            } else {
                return;
            }

            let newTitle = titleSplit[0];
            let color = titleSplit[1];
            productItemTitle.innerText = newTitle;
            let newColor = document.createElement('div');
            newColor.className = "boost-sd__product-color";
            newColor.innerText = color;

            let titleWrapper = document.createElement('div');
            titleWrapper.className = "boost-sd__product-title-wrapper";
            productItemTitle.parentNode.insertBefore(titleWrapper, productItemTitle);
            titleWrapper.appendChild(productItemTitle);
            titleWrapper.appendChild(newColor);

            let productItem = productItemTitle.closest('.boost-sd__product-item');
            let itemsForProduct = document.querySelectorAll(`.boost-sd__product-item[id="${productItem.id}"]`);
            if (itemsForProduct[0] !== productItem) {
                productItem.classList.add('boost-sd__product-item--hidden');
            }
        });
    });

    
    let updateState = () => {
        let productResults = Object.keys(window.searchState);
        productResults.map((product) => {
            let colors = window.searchState[product].colors
            let hitElements = document.querySelectorAll(`[data-handle="${product}"]`);
            let firstFound = false;
            hitElements.forEach((hitElement) => {   
                let swatches = hitElement.querySelector('.ais-hit--swatches');
                if (swatches) {
                    swatches.innerHTML = '';
                    if (colors.length > 1) {
                        colors.map(color => {
                            swatches.innerHTML += `<img class="ais-hit--swatch" src="${color.swatch}" alt="${color.color}" />`;
                        });
                    }
                    if (!firstFound) {
                        swatches.classList.add('ais-hit--swatches--open');
                        firstFound = true;
                    }
                }
            });
        });
        window.searchState = {};

        let facets = document.querySelectorAll('.ais-facet-dropdown-wrapper > label');
        facets.forEach((facet) => {
            if (facet.innerText === 'All Styles') return;
            facet.click();
        });
        
        document.querySelectorAll('.ais-Pagination-link').forEach(function(hit) {
            hit.addEventListener('click', function() {
                setTimeout(() => {
                    debugger;
                    waitForElm('.ais-hit').then(updateState);
                }, 1000);
            });
        });
    }
    waitForElm('.ais-hit').then(updateState);
});